import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `delayMs`. Lets a field drive a
 * server read without a request for every keystroke.
 */
export function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
